/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ObtainUnitSlugRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {ObtainUnitSlugResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const obtainUnitSlug = (request: ObtainUnitSlugRequest, options?: CashRequestOptions) => post<ObtainUnitSlugRequest, ObtainUnitSlugResponse>("/2.0/cash/obtain-unit-slug", request, {...options, rejectOnError: true })